import { useEffect, useState } from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';

import { getCurrentUser } from 'api';
import { colors } from 'config';
import { getErrorDetail } from 'helpers';
import { useSnackContext } from 'hooks';
import { UserProps } from 'types';

export const MasquaradeBanner = () => {
  const [user, setUser] = useState<UserProps | null>(null);
  const [gettingUser, setGettingUser] = useState(false);
  const { setSnack } = useSnackContext();

  useEffect(() => {
    const grabCurrentUser = async () => {
      try {
        setGettingUser(true);
        const data = await getCurrentUser();
        setGettingUser(false);
        setUser(data.data);
      } catch (e) {
        setGettingUser(false);

        setSnack((props) => ({
          ...props,
          severity: 'error',
          open: true,
          message: getErrorDetail({
            error: e,
            fallback: 'Failed To Get Current User',
          }),
        }));
      }
    };
    grabCurrentUser();
  }, [setSnack]);

  return (
    <Box
      color='white'
      sx={{
        width: '100%',
        backgroundColor: colors.blue,
        textAlign: 'center',
      }}
    >
      {gettingUser ? (
        <CircularProgress />
      ) : (
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          Acting as {user?.organization?.name}
        </Typography>
      )}
    </Box>
  );
};
